// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__yNH_J","location":"Header_location__1nyiU"};